var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{ref:"chatbot",staticClass:"chatbot",staticStyle:{"overflow-y":"scroll"}},[_vm._l((_vm.messageComponents),function(mc,i){return [_c(mc.component,_vm._b({key:i,tag:"component",on:{"selected":_vm.selectionMade,"next":_vm.moveAlong,"input":_vm.inputMade}},'component',{message: mc.message},false))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }